import hwpJsonKo from './ko/hwp.json';
import hwpMarkdownKo from './ko/hwp.md?raw';
import hwpXmlKo from './ko/hwp.xml?raw';
import slideJsonKo from './ko/pptx.json';
import slideMarkdownKo from './ko/pptx.md?raw';
import slideXmlKo from './ko/pptx.xml?raw';
import pdfJsonKo from './ko/pdf.json';
import pdfMarkdownKo from './ko/pdf.md?raw';
import pdfXmlKo from './ko/pdf.xml?raw';
import wordJsonKo from './ko/docx.json';
import wordMarkdownKo from './ko/docx.md?raw';
import wordXmlKo from './ko/docx.xml?raw';
import sheetJsonKo from './ko/sheet.json';
import sheetMarkdownKo from './ko/sheet.md?raw';
import sheetXmlKo from './ko/sheet.xml?raw';

import hwpJsonEn from './en/hwp.json';
import hwpMarkdownEn from './en/hwp.md?raw';
import hwpXmlEn from './en/hwp.xml?raw';
import slideJsonEn from './en/pptx.json';
import slideMarkdownEn from './en/pptx.md?raw';
import slideXmlEn from './en/pptx.xml?raw';
import pdfJsonEn from './en/pdf.json';
import pdfMarkdownEn from './en/pdf.md?raw';
import pdfXmlEn from './en/pdf.xml?raw';
import wordJsonEn from './en/docx.json';
import wordMarkdownEn from './en/docx.md?raw';
import wordXmlEn from './en/docx.xml?raw';
import sheetJsonEn from './en/sheet.json';
import sheetMarkdownEn from './en/sheet.md?raw';
import sheetXmlEn from './en/sheet.xml?raw';

export const getSampleArchiveType = (type: string) => (type === 'word' ? 'docx' : type);

export const SAMPLE_FILE_DATA = (language: string) => {
  switch (language) {
    case 'ko':
      return {
        hwp: { ...hwpJsonKo, markdown: hwpMarkdownKo, xml: hwpXmlKo },
        slide: { ...slideJsonKo, markdown: slideMarkdownKo, xml: slideXmlKo },
        pdf: { ...pdfJsonKo, markdown: pdfMarkdownKo, xml: pdfXmlKo },
        word: { ...wordJsonKo, markdown: wordMarkdownKo, xml: wordXmlKo },
        sheet: { ...sheetJsonKo, markdown: sheetMarkdownKo, xml: sheetXmlKo }
      };
    case 'en':
    default:
      return {
        hwp: { ...hwpJsonEn, markdown: hwpMarkdownEn, xml: hwpXmlEn },
        slide: { ...slideJsonEn, markdown: slideMarkdownEn, xml: slideXmlEn },
        pdf: { ...pdfJsonEn, markdown: pdfMarkdownEn, xml: pdfXmlEn },
        word: { ...wordJsonEn, markdown: wordMarkdownEn, xml: wordXmlEn },
        sheet: { ...sheetJsonEn, markdown: sheetMarkdownEn, xml: sheetXmlEn }
      };
  }
};
